import React from 'react';
import {
  BarChart2,
  Brain,
  AlertCircle,
  Users,
  Zap,
} from 'lucide-react';

const reports = [
  {
    id: 'r1',
    title: 'Workflow Activity',
    icon: <BarChart2 className="w-5 h-5 text-indigo-400" />,
    description: 'Summary of successful, failed, and in-progress workflows.',
    data: '14 successful / 2 failed today',
  },
  {
    id: 'r2',
    title: 'LLM Usage Stats',
    icon: <Brain className="w-5 h-5 text-pink-400" />,
    description: 'Tracks tokens, model calls, and estimated costs.',
    data: '3.1M tokens this week (~$8.40)',
  },
  {
    id: 'r3',
    title: 'Error & Failure Logs',
    icon: <AlertCircle className="w-5 h-5 text-red-400" />,
    description: 'Insights into errors across triggers and workflows.',
    data: '7 critical errors, 3 warnings',
  },
  {
    id: 'r4',
    title: 'User Access Summary',
    icon: <Users className="w-5 h-5 text-yellow-400" />,
    description: 'Tracks logins, role-based usage, and audit actions.',
    data: '9 users active this week',
  },
  {
    id: 'r5',
    title: 'Trigger Analytics',
    icon: <Zap className="w-5 h-5 text-teal-400" />,
    description: 'Analyzes most common API/schedule/chat triggers.',
    data: '74 chat triggers, 31 API triggers',
  },
];

const Reports = () => {
  return (
    <div className="space-y-6 max-w-5xl mx-auto">
      <div>
        <h2 className="text-xl font-semibold text-white">Reports & Insights</h2>
        <p className="text-sm text-gray-400">Get real-time visibility into system activity, usage, and access patterns.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {reports.map((report) => (
          <div
            key={report.id}
            className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 hover:border-indigo-500 transition"
          >
            <div className="flex items-center gap-4 mb-3">
              <div className="p-2 bg-neutral-800 rounded-full">{report.icon}</div>
              <h3 className="text-white text-lg font-medium">{report.title}</h3>
            </div>
            <p className="text-sm text-gray-400 mb-2">{report.description}</p>
            <p className="text-sm text-gray-300 font-mono">{report.data}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reports;
